import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Nav, NavItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import {
  useTranslator,
  useAppContext,
  withMobileAppMode,
  callNativeMobileApp,
} from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';

const NoDiet = ({ mobileAppMode, mealPlanNavigation }) => {
  const { t, language } = useTranslator();
  const navigate = useNavigate();
  const {
    images: { noDietEn, noDietSe, noDietPl, noDietCz },
    consts: { FIRST_DIET_SETTINGS_STEP_SLUG },
  } = useAppContext();

  const imageMap = {
    'en-US': {
      noDiet: noDietEn,
    },
    'sv-SE': {
      noDiet: noDietSe,
    },
    'pl-PL': {
      noDiet: noDietPl,
    },
    'pt-BR': {
      noDiet: noDietEn,
    },
    'cs-CZ': {
      noDiet: noDietCz,
    },
  };

  const renderImage = (name) => imageMap[language]?.[name] || null;

  const handleClick = (event) => {
    event.preventDefault();
    if (mobileAppMode) {
      callNativeMobileApp({
        action: 'open_modal',
        payload: {
          path: `/diet-settings/all/${FIRST_DIET_SETTINGS_STEP_SLUG}`,
          modal_variant: 'always_close_btn',
        },
      });
    } else {
      navigate(`/diet-settings/all/${FIRST_DIET_SETTINGS_STEP_SLUG}`);
    }
  };

  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('meals.navbarTitle')}</TitleBar>
      <div className="page-template-other full-height3a">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                {mealPlanNavigation && mealPlanNavigation.length > 0 && (
                  <div className="sub-navigation text-center">
                    <Container>
                      <Nav className="d-block">
                        {mealPlanNavigation.map((item) => (
                          <NavItem className="w-50">
                            <NavLink to={item.path} replace={true} className="nav-link">
                              {t(item.translationKey)}
                            </NavLink>
                          </NavItem>
                        ))}
                      </Nav>
                    </Container>
                  </div>
                )}
                <div
                  className={
                    mobileAppMode
                      ? 'other-container text-center d-flex align-items-center min-height'
                      : 'other-container text-center'
                  }
                >
                  <Row>
                    <Col xl={{ size: 6, offset: 3 }}>
                      <img
                        src={renderImage('noDiet')}
                        className="img-fluid mb-xl border-radius"
                        alt=""
                      />
                      <h2 className="title-medium semi-bold">
                        {t('mealPlan.noDiet.screen.title')}
                      </h2>
                      <p className="mb-xl text-text-variant-color">
                        {t('app.mealPlan.noDiet.screen.content')}
                      </p>
                      <Button color="primary" className="w-100" onClick={handleClick}>
                        {t('mealPlan.noDiet.screen.button')}
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default withMobileAppMode(NoDiet);
